import { memo } from 'react';

import { Slot } from '@radix-ui/react-slot';
import cx from 'classnames';

import { css, type CSS } from '@clubspark-react/ui/components/stitches.config';
import { type ClassName, type IWtn } from '@clubspark-react/ui/components/types';
import { usePoppinsFont } from '@clubspark-react/ui/hooks';
import Checkmark from '@clubspark-react/ui/icons/WtnCheckmark';

import { wtnDecimalStyles, wtnMarkStyles, wtnStyles } from './Wtn.styles';

type WtnClasses = 'root' | 'decimal' | 'mark';
export interface WtnProps {
  asChild?: boolean;
  confident?: IWtn['confident'];
  className?: ClassName;
  classNames?: Partial<Record<WtnClasses, string>>;
  hideMark?: boolean;
  props?: Partial<Record<WtnClasses, Record<string, any>>>;
  styles?: Partial<Record<WtnClasses, CSS>>;
  sx?: CSS;
  children: IWtn['value'];
}

function Wtn({
  asChild,
  confident,
  className,
  classNames,
  hideMark,
  styles,
  props,
  children,
  sx,
}: WtnProps): JSX.Element {
  usePoppinsFont();
  const Comp = asChild ? Slot : 'data';
  const [number, decimal] = (children || 0).toFixed(2).split('.');

  return (
    <Comp
      className={cx(wtnStyles(sx && { css: sx }), styles?.root && css(styles.root)(), className, classNames?.root)}
      value={children}
      {...props?.root}
    >
      {children ? (
        <>
          {number}.
          <span
            className={cx(wtnDecimalStyles(), classNames?.decimal, styles?.decimal && css(styles.decimal)())}
            {...props?.decimal}
          >
            {decimal}
          </span>
        </>
      ) : (
        '-'
      )}
      {!hideMark && (
        <Checkmark
          className={cx(wtnMarkStyles(), classNames?.mark, styles?.mark && css(styles.mark)())}
          fill={confident ? '#003A70' : '#D0D3DB'}
          height={8}
          width={8}
          {...props?.mark}
        />
      )}{' '}
    </Comp>
  );
}

export default memo(Wtn);
